import React, { PropTypes } from 'react'
import data from '../../../core/data';

const PhytoIntro = (props) => {
  const body = data.ppeel.intro.body;
  return (
    <section id="p-peel-intro">
      <div className="container">
        <div className="row">
          <h1 className="header">Alex Cosmetics Phyto™ Treatments</h1>
          <p>{ body }</p>
        </div>
      </div>
    </section>
  )
}

export default PhytoIntro



/** WEBPACK FOOTER **
 ** ./src/components/containers/ppeel/PhytoIntro.jsx
 **/